import type {
  Reference as ReferenceType,
  Identifier,
  Extension,
} from 'fhir/r4';

export default class Reference implements ReferenceType {
  display?: string | undefined;
  _display?: Element | undefined;
  identifier?: Identifier | undefined;
  reference?: string | undefined;
  _reference?: Element | undefined;
  type?: string | undefined;
  _type?: Element | undefined;
  extension?: Extension[] | undefined;

  constructor(referenceString: string) {
    this.reference = referenceString;
  }
}
